import { GetterTree } from 'vuex';
import RootState from '@/types/store/booking/RootState';
import I18nState from '@/types/store/i18n/I18nState';

const getters: GetterTree<I18nState, RootState> = {
  locale(state): string | null {
    return state.locale;
  },
  translations(state): { [path: string]: string } {
    return state.translations;
  },
};

export default getters;
